import { babi } from "@tsogtoodev/babi-toast"

// Curated: errors that warrant an "upgrade plan" CTA.
// Not a prefix — subscription.wrong_source is intentionally excluded.
const UPGRADE_ERRORS = new Set([
  "synthesize.max_characters_exceeded",
  "synthesize.max_characters_per_conversion_exceeded",
  "subscription.expired",
  "subscription.max_characters_exceeded",
  "subscription.max_characters_per_conversion_exceeded",
  "subscription.no_active_subscription",
])

export default defineNuxtPlugin((nuxtApp) => {
  const currentUser = useCurrentUser()

  const api = $fetch.create({
    baseURL: "/api/v1",
    async onRequest({ options }) {
      if (currentUser.value) {
        const token = await currentUser.value.getIdToken()
        options.headers.set("Authorization", `Bearer ${token}`)
      }
    },
    onResponseError({ response }) {
      const code =
        (response._data as string)?.replaceAll?.("\n", "") || "unknown_error"

      nuxtApp.runWithContext(() => {
        if (response.status === 401) return navigateTo("/auth")

        const { t, te } = nuxtApp.$i18n as {
          t: (key: string) => string
          te: (key: string) => boolean
        }
        const key = `errors.${code}`

        if (!te(key)) {
          return babi.error({
            fill: "#2b2a29",
            title: t("errors.request_failed"),
            duration: 6000,
          })
        }

        const id = babi.warning({
          fill: "#2b2a29",
          title: t("common.warning"),
          description: t(key),
          duration: 6000,
          ...(UPGRADE_ERRORS.has(code) && {
            button: {
              title: t("app.profile.upgradePlan"),
              onClick: () => {
                babi.dismiss(id)
                nuxtApp.runWithContext(() => navigateTo("/app/account/billing"))
              },
            },
          }),
        })
      })
    },
  })

  /*
   * Expose to useNuxtApp().$api
   *
   * - Example: Usage with useAPI composable
   * const { data } = await useAPI<User>("/me")
   *
   * - Example: Usage with $api directly
   * const { $api } = useNuxtApp()
   * const redirectURL = await $api<string>(`/subscriptions/buy`)
   */
  return {
    provide: {
      api,
    },
  }
})
